import { render } from "./AppAddButton.vue?vue&type=template&id=37e00577&scoped=true&ts=true"
import script from "./AppAddButton.vue?vue&type=script&lang=ts"
export * from "./AppAddButton.vue?vue&type=script&lang=ts"

import "./AppAddButton.vue?vue&type=style&index=0&id=37e00577&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e00577"]])

export default __exports__